import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  FaFacebookF, FaTwitter, FaInstagram, FaLinkedin,
  FaYoutube, FaTiktok, FaEnvelope, FaPhone, FaWhatsapp
} from 'react-icons/fa';
import './TopBar.css';

function TopBar() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    axios.get('https://api.hospifylink.com/api/footer/settings').then(r => setSettings(r.data)).catch(() => {});
  }, []);

  const EMAIL = settings?.email || 'karurangabelyse911@gmail.com';
  const PHONE_DISPLAY = settings?.phone || '+250 789 951 922';
  const PHONE_RAW = (settings?.whatsapp_number || '250789951922').replace(/\D/g, '');

  const whatsappUrl = `https://wa.me/${PHONE_RAW}?text=${encodeURIComponent(
    settings?.whatsapp_message || 'Hello Hospify Link team!'
  )}`;

  const socials = [
    // { name: 'Facebook', icon: <FaFacebookF />, color: '#1877f2', url: settings?.facebook_url || '#' },
    // { name: 'Twitter', icon: <FaTwitter />, color: '#1da1f2', url: settings?.twitter_url || '#' },
    { name: 'Instagram', icon: <FaInstagram />, color: '#e4405f', url: settings?.instagram_url || '#' },
    // { name: 'LinkedIn', icon: <FaLinkedin />, color: '#0077b5', url: settings?.linkedin_url || '#' },
    // { name: 'YouTube', icon: <FaYoutube />, color: '#ff0000', url: settings?.youtube_url || '#' },
    { name: 'TikTok', icon: <FaTiktok />, color: '#ffffff', url: settings?.tiktok_url || '#' },
    { name: 'WhatsApp', icon: <FaWhatsapp />, color: '#25d366', url: whatsappUrl }
  ];

  return (
    <div className="topbar-root">
      <div className="topbar-contact">
        <a href={`mailto:${EMAIL}`} className="topbar-contact-item"><FaEnvelope /> <span>{EMAIL}</span></a>
        <a href={`tel:+${PHONE_RAW}`} className="topbar-contact-item"><FaPhone /> <span>{PHONE_DISPLAY}</span></a>
      </div>
      <div className="topbar-socials">
        {socials.map((s, i) => (
          <a key={i} href={s.url} className="topbar-social-icon"
            style={{ color: s.color, animationDelay: `${i * 0.25}s` }}
            target="_blank" rel="noreferrer" title={s.name}>
            {s.icon}
          </a>
        ))}
      </div>
    </div>
  );
}

export default TopBar;
